export default "__VITE_ASSET__Co$1ea6$__"